export default "__VITE_ASSET__BvdWMGSh__"